export namespace ConstParams {
  export const CAT_ACCOMM = 'ACCOMM';
  export const CAT_ATTRACTION = 'ATTRACTION';
  export const CAT_DEST_INFO = 'DESTINFO';
  export const CAT_TOUR = 'TOUR';
  export const CAT_EVENT = 'EVENT';
  export const CAT_FANDDRINK = 'RESTAURANT';
  export const CAT_JOURNEY = 'JOURNEY';
  export const CAT_TOUR_OPERATOR = 'TOUROPERATOR';
  export const CAT_GEN_SERVICE = 'GENSERVICE';
  export const CAT_HIRE = 'HIRE';
  export const CAT_INFO_SERVICE = 'INFO';
  export const CAT_TRANS_PORT = 'TRANSPORT';
  export const CAT_PLAN_VISIT = 'Plan Your Visit';
  export const CAT_EXP = 'Experience';
  export const PLAN_YOUR_VISIT_ROUTE = 'planyourvisit';
  export const EXPERIENCE_ROUTE = 'experience';
}
